<div class="exam-template-dialog">
  <h1 mat-dialog-title>{{ 'liveEvents.setup.label.select' | translate }}</h1>
  <div mat-dialog-content>
    <mat-radio-group [(ngModel)]="template">
      @for (temp of templates; track temp.value; let i = $index) {
      <div class="radio-btn">
        {{ temp.name | translate }}
        <mat-radio-button
          color="primary"
          [value]="temp"
          name="select"
        ></mat-radio-button>
      </div>
      @if (i < templates.length - 1) {
      <mat-divider></mat-divider>
      } }
    </mat-radio-group>
  </div>
  <div mat-dialog-actions class="import-btn">
    <qa-button
      label="{{ 'common.button.cancel' | translate }}"
      mat-dialog-close
    >
    </qa-button>
    <qa-button
      cdkFocusInitial
      [isRaisedButton]="true"
      [disabled]="!template"
      label="{{ 'common.button.import' | translate }}"
      (click)="selectTemplate()"
    >
    </qa-button>
  </div>
</div>
